;(function () {
  'use strict'

  angular
    .module('contrast.auth')
    .directive('addClassIfNotAuthenticated', addClassIfNotAuthenticated)

  function addClassIfNotAuthenticated() {
    var notAuthenticatedPages = [
      '/pages/signin',
      '/pages/expired',
      '/pages/update-password',
      '/pages/forgot-password',
      '/pages/register',
      '/tsv/verification',
      '/tsv/signin',
      '/tsv/backup-code',
      '/tsv/setup',
      '/survey',
      '/freemium/activation'
    ]

    return {
      restrict: 'A',
      controller: [
        '$scope',
        '$element',
        '$location',
        '$attrs',
        addClassIfNotAuthenticatedCtrl
      ]
    }

    function addClassIfNotAuthenticatedCtrl(
      $scope,
      $element,
      $location,
      $attrs
    ) {
      var addBg, path
      var newClass = $attrs.classAdded
      path = function () {
        return $location.path()
      }
      addBg = function (path) {
        $element.removeClass(newClass)

        for (var i = 0; i < notAuthenticatedPages.length; i++) {
          if (path.indexOf(notAuthenticatedPages[i]) != -1) {
            return $element.addClass(newClass)
          }
        }
      }
      addBg($location.path())
      return $scope.$watch(path, function (newVal, oldVal) {
        if (newVal === oldVal) {
          return
        }
        return addBg($location.path())
      })
    }
  }
})()
